/** @jsx jsx */
import { Box, jsx } from "theme-ui"
import Heading from './heading'
import Text, { Markdown, } from './text'
import { ClickableText, ExternalLink, AnchorLink, InstagramLink, } from './link'
import ArtworkMeta from './artwork-meta'
import GoogleMapComponent from './map'
import { navigate } from "gatsby"
import AppFeatures from "./app-features"
import AppStoreBadges from "./AppStoreBadges"

export default function ArtworkDetail({ art }) {
    return <div style={{maxWidth: '1200px', margin: '0 auto'}}>
        {!!art && <div style={{padding: '24px 40px', backgroundColor: '#fff',}}>
            <div style={{marginBottom: '40px', textAlign: 'right',}}>
                <img src={art.image_url} style={{maxWidth: '100%',}} />
                {!!art.photographer && <Text small secondary>Photograph by {art.photographer}</Text>}
            </div>


            <div style={{maxWidth: '700px', margin: '16px auto 40px',}}>
                <ClickableText ssx={{mb: 3,}} onClick={() => navigate(-1)}>&#x21e6; back</ClickableText>
                <Heading>{art.title.trim()}{(art.year ? ', ' : '')}{art.year}</Heading>
                <Heading weightNormal type={2}>by {art.artist}</Heading>

                <ArtworkMeta artwork={art} />
                <AnchorLink to="map">Go to map &darr;</AnchorLink>
            
                <div style={{marginTop: '12px',}}>

                    <Markdown>{art.summary}</Markdown>

                    {(!!art.artist_bio_short || !!art.artist_bio) && <div>
                        <Heading type={3}>Artist bio</Heading>
                        <Markdown>{art.artist_bio ? art.artist_bio : art.artist_bio_short}</Markdown>
                    </div>}
                    
                    {(!!art.artist_contact && art.artist_contact.indexOf('[') === 0) && <ExternalLink href={art.artist_contact.split('](')[1].replace(')', '')}>{art.artist_contact.split('](')[0].replace('[', '')}</ExternalLink>}
                    
                    <div style={{flexDirection: 'column', marginBottom: '8px',}}>
                        {!!art.artist_ig_profile && art.artist_ig_profile.split(' ').map((profile, i) => <InstagramLink key={i} profile={profile.replace('@', '')} />)}
                    </div>
                    {!!art.artist_website && <div><ExternalLink href={art.artist_website}>{art.artist}'s website</ExternalLink></div>}
                    
                </div>
                <div sx={{
                    marginTop: 5,
                    borderRadius: 4,
                    paddingX: [3, 5],
                    paddingY: [3, 4],
                    background: 'textSuperLight',
                }}>
                    <Text large>Get Directions and more with the free mobile app</Text>
                    <AppFeatures />
                    <Box sx={{mt: 2}}>
                        <AppStoreBadges />
                    </Box>
                </div>
            </div>


            <div id="map">
                <GoogleMapComponent id={art.id} coords={art.coords} title={art.title} />
            </div>
        </div>}
    </div>
}